import {
  MDBContainer, MDBRow, MDBCol, MDBBtn,
} from 'mdbreact';
import React, { useContext, useRef } from 'react';
import { UserContext } from '../UserContext';

function AddUser() {
  const baseURL = process.env.REACT_APP_API_BASEURL;
  const userContext = useContext(UserContext);

  const emailId = useRef(null);
  const joiningYear = useRef(null);
  const studentName = useRef(null);

  const addUser = (event) => {
    event.preventDefault();

    // Token Expired or some Auth Issues
    if (userContext.name === '') {
      alert('Not Authorized');
      return;
    }

    fetch(`${baseURL}/api/admin/user`, {
      method: 'POST',
      body: JSON.stringify({
        display_name: studentName.current.value,
        email_id: emailId.current.value,
        joining_year: joiningYear.current.value,
        is_active: true,
      }),
      headers: {
        Authorization: `${userContext.tokenID}`,
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          alert('User Added Successfully.');

          studentName.current.value = '';
          emailId.current.value = '';
          joiningYear.current.value = '';
        } else {
          const responseData = res.json();
          responseData.then((response) => {
            alert(response.error);
          });
          console.log(res.status);
        }
      })
      .catch((err) => {
        alert('POST Request Failed, Please try again later');
        console.log(err);
      });
  };

  return (
    <>
      <MDBContainer style={{ marginBottom: '1.5rem', marginTop: '1rem' }} fluid>
        <MDBRow center>
          <MDBCol md="6">
            <form onSubmit={addUser}>
              <p className="h2 text-center mb-1">Add New User</p>
              <br />
              <label htmlFor="studentName" className="black-text">
                Student Name
              </label>
              <input
                type="text"
                id="studentName"
                className="form-control"
                ref={studentName}
                required
              />
              <br />
              <label htmlFor="email" className="black-text">
                Student Email Id
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                ref={emailId}
                required
              />
              <br />
              <label htmlFor="joiningYear" className="black-text">
                Joining Year
              </label>
              <input
                type="text"
                id="joiningYear"
                className="form-control"
                ref={joiningYear}
                required
              />

              <br />
              <div className="text-center mt-4">
                <MDBBtn color="primary" type="submit">
                  Add User
                </MDBBtn>
              </div>
            </form>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </>
  );
}

export default AddUser;
